/**
 * Created by zzy on 2019/8/28.
 */
import HandleAlarmEventModal from './HandleAlarmEventModal.vue'
export default HandleAlarmEventModal



// WEBPACK FOOTER //
// ./src/views/common/handleAlarmEventModal/index.js